exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon-contact[data-v-1d52bbca] {\r\n  -webkit-filter: brightness(0.45);\r\n          filter: brightness(0.45);\r\n  width: 40px;\r\n  height: 40px;\n}\r\n", ""]);

// exports
